import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgRowsFill = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M24.5 16.625V21a1.75 1.75 0 0 1-1.75 1.75H5.25A1.75 1.75 0 0 1 3.5 21v-4.375a1.75 1.75 0 0 1 1.75-1.75h17.5a1.75 1.75 0 0 1 1.75 1.75ZM22.75 5.25H5.25A1.75 1.75 0 0 0 3.5 7v4.375a1.75 1.75 0 0 0 1.75 1.75h17.5a1.75 1.75 0 0 0 1.75-1.75V7a1.75 1.75 0 0 0-1.75-1.75Z" />
  </svg>
);
export default SvgRowsFill;
